const tipoTributacao = {
  ISENTO_ISS: '1 - Isento de ISS',
  IMUNE: '2 - Imune',
  NAO_INCI_MUNICIPIO: '3 - Não Incidência no Município',
  NAO_TRIBUTAVEL: '4 - Não Tributável',
  RETIDO: '5 - Retido',
  TRIB_DENTRO_MUNICIPIO: '6 - Tributável Dentro do Município',
  TRIB_FORA_MUNICIPIO: '7 - Tributável Fora do Município',
};

export default tipoTributacao;
